import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';

// Notetaker toggle styles
// Color constants

// Brand refresh (product refresh 2026) "on" background: vivid brand AI gradient
// (purple → blue). The *SurfaceActionLight tokens are pale 100-level pastels, so the
// vivid gradient composite is used instead.

// Brand refresh track sizing — fixed width so the handle can slide between
// off (left) and on (right) now that the On/Off text label is gone.

const toggleContainerTogglePositionOnCss = "tyalzjl";
const toggleContainerToggleDisabledCss = "t1p4lvn5";
const toggleContainerShowErrorStateCss = "t1gu0k3t";
const toggleContainerBrandRefreshCss = "t1w917ft";

/**
 * Styled toggle button component that serves as the main container for the notetaker toggle.
 * Handles different visual states: on/off, hover, disabled, and error states.
 * Includes accessibility attributes for switch role.
 *
 * Two visual treatments:
 * - Legacy: a rounded pill with an "On"/"Off" text label beside the handle.
 * - Brand refresh: a fixed-width, icon-only track where the handle slides left→right.
 */
const toggleContainerCss = "tyma2ac";
export const ToggleContainer = forwardRef((props, ref) => {
  const {
    togglePositionOn,
    toggleDisabled,
    showErrorState,
    brandRefresh,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(toggleContainerCss, {
    [toggleContainerTogglePositionOnCss]: togglePositionOn,
    [toggleContainerToggleDisabledCss]: toggleDisabled,
    [toggleContainerShowErrorStateCss]: showErrorState,
    [toggleContainerBrandRefreshCss]: brandRefresh
  }, props.className)} />;
});
const toggleHandleToggleDisabledCss = "twul8m6";
const toggleHandleTogglePositionOnCss = "t1men1as";
const toggleHandleIsSpotlightCss = "tx19o8q";
const toggleHandleBrandRefreshCss = "ttorngb";
const toggleHandleCss = "to8fzdl";
export const ToggleHandle = forwardRef((props, ref) => {
  const {
    toggleDisabled,
    togglePositionOn,
    isSpotlight,
    brandRefresh,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(toggleHandleCss, {
    [toggleHandleToggleDisabledCss]: toggleDisabled,
    [toggleHandleTogglePositionOnCss]: togglePositionOn,
    [toggleHandleIsSpotlightCss]: isSpotlight,
    [toggleHandleBrandRefreshCss]: brandRefresh
  }, props.className)} />;
});
const toggleTextToggleDisabledCss = "t1x1qic8";
const toggleTextTogglePositionOnCss = "t1ah8pe3";
const toggleTextCss = "t12vq82i";
export const ToggleText = forwardRef((props, ref) => {
  const {
    toggleDisabled,
    togglePositionOn,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(toggleTextCss, {
    [toggleTextToggleDisabledCss]: toggleDisabled,
    [toggleTextTogglePositionOnCss]: togglePositionOn
  }, props.className)} />;
});
const wrapperCss = "w19xq7x7";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const toggleIconTogglePositionOnCss = "t1d9r313";
const toggleIconBrandRefreshCss = "tff5vsa";
const toggleIconCss = "t1hhymnj";
export const ToggleIcon = forwardRef((props, ref) => {
  const {
    togglePositionOn,
    brandRefresh,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(toggleIconCss, {
    [toggleIconTogglePositionOnCss]: togglePositionOn,
    [toggleIconBrandRefreshCss]: brandRefresh
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");